export default host => (token) =>`${host}/public/playlists/${token}/downloadZip`
